<template>
  <div id="app">
    <div class="app_top">
      <div class="toplogo"><img src="./assets/Johnsonlogo.png" /></div>
      <div class="topMenu" v-if="menuflag">
        <div class="topMenuItem" :class="menuIndex==0?'MenuActive':''" @click="myTo('Rmzb',0)">首页</div>
        <!-- <div class="topMenuItem" :class="menuIndex==1?'MenuActive':''" @click="myTo('Rmzb',1)">热门直播</div> -->
        <div class="topMenuItem" :class="menuIndex==2?'MenuActive':''" @click="myTo('Zbgy',2)">直播公约</div>
        <div class="topMenuItem" :class="menuIndex==3?'MenuActive':''" @click="myTo('Zjcns',3)">直播承诺书</div>
        <div class="topMenuItem" :class="menuIndex==4?'MenuActive':''" @click="myTo('Fwxy',4)">服务协议</div>
        <div class="topMenuItem" :class="menuIndex==5?'MenuActive':''" @click="myTo('Jfcl',5)">纠纷处理</div>
        <div class="topMenuItem" :class="menuIndex==6?'MenuActive':''" @click="myTo('Wcnrbhzd',6)">未成年人保护制度</div>
        <div class="topMenuItem" :class="menuIndex==7?'MenuActive':''" @click="myTo('Nrzsglzd',7)">内容自审管理制度</div>
        <!-- <div class="topMenuItem" :class="menuIndex==8?'MenuActive':''" @click="myTo('Jguan',8)">监管</div> -->
      </div>
      <div class="top_right" @click="ToLogin">登录/注册</div>
    </div>

    <div style="min-height: 800px;">
      <router-view/>
    </div>

    <div class="app_bottom">
      <div class="app_bottom_content">
        <div class="btm_content_top">
          <ul>
            <li @click="myTo('Rmzb',0)">首页</li>
            <li @click="myTo('Zbgy',2)">直播公约</li>
            <li>直播承诺书</li>
            <li>服务协议</li>
          </ul>
          <ul>
            <li @click="myTo('Rmzb',1)">热门直播</li>
            <li>纠纷处理</li>
            <li>未成年人保护制度</li>
            <li>内容自审管理制度</li>
          </ul>
        </div>
        <div class="btm_content_btm">
          <div class="btm_Item">
            <span>CONTACT</span>
            <span>COPYRIGHT</span>
          </div>
          <div class="btm_Item">
            <span>天津市红桥区咸阳北路46号银泰科技大厦B座605-2-20</span>
            <span>&copy; 2023喜哈文化传媒（天津）有限公司</span>
          </div>
          <div class="btm_Item">
            <span>400-40000-000</span>
            <span>津ICP备2022008983号</span>
          </div>
          <div class="btm_Item">
            <span></span>
            <span>Designed by:天津</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      menuIndex: null,
      menuflag: true
    }
  },
  mounted () {
    var muind = sessionStorage.getItem('menuIndex')
    if (muind != null && muind !== '') {
      this.menuIndex = muind
    }
  },
  methods: {
    myTo (path, i) {
      this.menuIndex = i
      sessionStorage.setItem('menuIndex', this.menuIndex)
      this.$router.push({name: path})
      document.documentElement.scrollTop = 0
    },
    ToLogin () {
      this.menuIndex = 9
      this.$router.push({name: 'Login'})
    }
  }
}
</script>

<style>
*{margin: 0px;}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0px;
  padding: 0px;
}
:-webkit-scrollbar{
  width: 0 !important;
}
::-webkit-scrollbar{
  width: 0 !important;height: 0;
}
.app_top{width: 100%;height: 54px;background-color: #000;position: fixed;top: 0px;display: flex;align-items: center;color: #fff;justify-content: space-between;z-index: 999;}
.app_top .toplogo img{width: 130px;margin-left: 15px;margin-top: 5px;}
.topMenu .topMenuItem{float: left;margin-right: 26px;cursor: pointer;font-size: 12pt;height: 52px;line-height: 54px;}
.topMenu .MenuActive{font-size: 14pt;border-bottom: 2px solid #A50D10;}
.app_top .top_right{margin-right: 15px;font-size: 12pt;cursor: pointer;}

.app_bottom{width: 100%;padding: 20px 0px;background-color: #222;color: #fff;height: 210px;}
.app_bottom .app_bottom_content{margin: 0px 80px;}
.app_bottom .app_bottom_content .btm_content_top{width: 100%;border-bottom: 1px solid #fff;padding-bottom: 20px;height: 80px;font-size: 10pt;}
.app_bottom .app_bottom_content .btm_content_top ul{float: left;list-style: none;margin-right: 30px;padding: 0px;}
.app_bottom_content .btm_content_top ul li{margin-bottom: 6px;}
.btm_content_btm{padding-top: 10px;}
.btm_content_btm .btm_Item{display: flex;width: 100%;justify-content: space-between;font-size: 10pt;padding-top: 6px;}
</style>



// WEBPACK FOOTER //
// src/App.vue